// extracted by mini-css-extract-plugin
export default {"wrapper":"Ld","form":"Md","label":"Nd","asterisk":"Od","smallprint":"Pd","success":"Qd","circle":"Rd"};